export default __webpack_public_path__ + "assets/rocket-71d13a6.svg";